import React from "react";
import { any, arrayOf, object, shape, string, func, bool } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Resources from "../../components/Resources";
import ConfirmPDFResource from "../../components/ConfirmPDFResource/ConfirmPDFResource";
import {
  downloadHrGoKidPdf,
  downloadPayrollKidPdf,
  downloadHrGoPlcKidPdf,
  downloadNewHrGoPlcKidPdf,
  hrgoKidPdfUrl,
  payrollKidPdfUrl,
  hrgoPlcKidPdfUrl,
  newHrgoPlcKidPdfUrl,
  submitContractForServices,
  downloadContractForServices,
  contractForServicesUrl,
} from "../../api/profileApi";

import {
  findUmbraccoResources,
  isDownloadAttrSupported,
  forceDownload,
} from "./util";

import { contractForServicesSubmitted } from "../../redux/actions/formActions";

const contractForServicesFormName =
  "Contract_For_Services_-_HR_GO_Recruitment_Ltd.pdf";

const contractForServicesDriverFormName = "Contract_for_Services_-_Driving.pdf";

const contractForServicesFormPath = "contractForServices";

const hrgoKidDownload = async (name, team, createdAt) => {
  if (isDownloadAttrSupported()) {
    return downloadHrGoKidPdf(name, team, createdAt).then((response) =>
      forceDownload(response, "HRGO Recruitment Payroll KID £8.91ph.pdf")
    );
  }
  return window.open(hrgoKidPdfUrl(name, team, createdAt), "_blank");
};

const payrollKidDownload = async (name, team, index, filename, createdAt) => {
  if (isDownloadAttrSupported()) {
    return downloadPayrollKidPdf(name, team, createdAt, index).then(
      (response) => forceDownload(response, filename)
    );
  }
  return window.open(payrollKidPdfUrl(name, team, createdAt, index), "_blank");
};

const contractForServicesDownload = async (
  formName,
  filename,
  complete,
  isDriver,
  createdAt
) => {
  if (isDownloadAttrSupported()) {
    return downloadContractForServices(complete, isDriver, createdAt).then(
      (response) => forceDownload(response, filename)
    );
  }
  return window.open(
    contractForServicesUrl(formName, filename, complete, isDriver, createdAt),
    "_blank"
  );
};

const hrgoPlcKidDownload = async (name, team, createdAt) => {
  if (isDownloadAttrSupported()) {
    return downloadHrGoPlcKidPdf(name, team, createdAt).then((response) =>
      forceDownload(response, "HRGO PLC Kid.pdf")
    );
  }
  return window.open(hrgoPlcKidPdfUrl(name, team, createdAt), "_blank");
};

const newHrgoPlcKidDownload = async (name, team, createdAt) => {
  if (isDownloadAttrSupported()) {
    return downloadNewHrGoPlcKidPdf(name, team, createdAt).then((response) =>
      forceDownload(response, "HRGO PLC Kid - 02.04.23.pdf")
    );
  }
  return window.open(newHrgoPlcKidPdfUrl(name, team, createdAt), "_blank");
};

const contractForServicesForm = (
  appData,
  setContractForServicesSubmitted,
  forceDownloadViaSnackbar
) => {
  return (
    <ConfirmPDFResource
      forceDownloadViaSnackbar={forceDownloadViaSnackbar}
      hasFile={appData.contractForServicesHandling}
      title="Contract for Services"
      description="Terms of engagement for PAYE temp workers. You have accepted the terms of this contract. Please click on the download button to view your signed contract. If you have any queries about the contract, please speak to your HRGO consultant."
      downloadPDFFile={async (complete) =>
        contractForServicesDownload(
          contractForServicesFormPath,
          appData.lookingForDrivingJob
            ? contractForServicesDriverFormName
            : contractForServicesFormName,
          complete,
          appData.lookingForDrivingJob,
          appData.permissions.cfsSentDate || appData.createdAt
        )
      }
      submitResourceAgreement={async () => {
        setContractForServicesSubmitted();
        return submitContractForServices(
          `${appData.firstName} ${appData.lastName}`,
          appData.address,
          `${appData.positionSeeking}`,
          `${appData.responsibleTeam}`,
          `${appData.lookingForDrivingJob}`,
          `${appData.permissions.cfsSentDate || appData.createdAt}`
        ).then((response) => {
          if (isDownloadAttrSupported()) {
            return forceDownload(
              response,
              appData.lookingForDrivingJob
                ? contractForServicesDriverFormName
                : contractForServicesFormName
            );
          }
          return window.open(
            contractForServicesUrl(
              contractForServicesFormPath,
              appData.lookingForDrivingJob
                ? contractForServicesDriverFormName
                : contractForServicesFormName,
              true,
              appData.lookingForDrivingJob,
              appData.permissions.cfsSentDate || appData.createdAt
            ),
            "_blank"
          );
        });
      }}
    />
  );
};

const oldPayrollCompanyKids = (appData) => {
  if (Array.isArray(appData.payrollCompany && appData.payrollCompany.payroll)) {
    const dateAccCreated = new Date(appData.createdAt);
    const synergyStartDate = new Date("2020-04-06");
    const synergyEndDate = new Date("2021-05-11");

    if (
      // for HRGO edu SE only & not to see Synergy KID
      appData.payrollCompany.employmentBusiness ===
        "HRGO Recruitment Education (SE) Limited" &&
      dateAccCreated > synergyEndDate &&
      dateAccCreated < synergyStartDate
    ) {
      return [
        {
          cta: "AZebra KID",
          handler: async () =>
            payrollKidDownload(
              `${appData.firstName} ${appData.lastName}`,
              appData.responsibleTeam,
              0,
              "HRGO Ed SE KID form AZebra (Fillable).pdf",
              dateAccCreated
            ),
        },
        {
          cta: "HRGO PLC KID",
          handler: async () =>
            payrollKidDownload(
              `${appData.firstName} ${appData.lastName}`,
              appData.responsibleTeam,
              1,
              "HRGO PLC KID.pdf",
              dateAccCreated
            ),
        },
      ];
    }
    // all other mutliple payroll companies
    return appData.payrollCompany.payroll.map((cObj, index) => {
      return (
        appData.payrollCompany && {
          cta: `${cObj.companyName} KID`,
          handler: async () =>
            payrollKidDownload(
              `${appData.firstName} ${appData.lastName}`,
              appData.responsibleTeam,
              index,
              cObj.companyName,
              dateAccCreated
            ),
        }
      );
    });
  }

  if (
    appData.responsibleTeam === "HEDE" ||
    appData.responsibleTeam === "HEDH"
  ) {
    return [
      {
        cta: "talentED Recruiters Limited KID",
        handler: async () =>
          hrgoKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            appData.createdAt
          ),
      },
    ];
  }

  const singlePayrollButtons = [
    {
      cta: "HRGO Recruitment KID",
      handler: async () =>
        hrgoKidDownload(
          `${appData.firstName} ${appData.lastName}`,
          appData.responsibleTeam,
          appData.createdAt
        ),
    },
  ];

  if (appData.payrollCompany && appData.payrollCompany.payroll) {
    singlePayrollButtons.unshift({
      cta: `${appData.payrollCompany.payroll.companyName} KID`,
      handler: async () =>
        payrollKidDownload(
          `${appData.firstName} ${appData.lastName}`,
          appData.responsibleTeam,
          0,
          appData.payrollCompany.payroll.filename,
          appData.createdAt
        ),
    });
  }

  return singlePayrollButtons;
};

const kidDocumentButtons = (appData, createdAt) => {
  const createdDate = new Date(createdAt);

  if (
    createdDate > new Date("2021-06-27") &&
    createdDate < new Date("2021-07-07")
  ) {
    return [
      {
        cta: "HRGO Recruitment KID",
        handler: async () =>
          hrgoKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
      {
        cta: "HRGO PLC KID",
        handler: async () =>
          hrgoPlcKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
      {
        cta: "HRGO PLC KID - 02.04.23",
        handler: async () =>
          newHrgoPlcKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
    ];
  }

  if (createdDate > new Date("2023-10-18")) {
    return [
      {
        cta: "HRGO PLC KID",
        handler: async () =>
          hrgoPlcKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
    ];
  }

  if (createdDate > new Date("2021-07-07")) {
    return [
      {
        cta: "HRGO PLC KID",
        handler: async () =>
          hrgoPlcKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
      {
        cta: "HRGO PLC KID - 02.04.23",
        handler: async () =>
          newHrgoPlcKidDownload(
            `${appData.firstName} ${appData.lastName}`,
            appData.responsibleTeam,
            createdDate
          ),
      },
    ];
  }

  return oldPayrollCompanyKids(appData);
};

const keyInformationDocument = (appData, createdAt) => ({
  title: "Key Information Document (KID)",
  description: `The Key Information Document (KID) is to improve the transparency of information around your pay. It is to give a clear idea of how any fees and deductions may affect your pay and the type of deductions you can expect to see.<br /><br />The KID does not include all relevant contractual information or personal figures, these are included in your contract and Assignment Details, the KID is purely an illustrative document.`,
  buttons: kidDocumentButtons(appData, createdAt),
});

const ResourcesHRGOContainer = ({
  resources,
  appData,
  createdAt,
  setContractForServicesSubmitted,
  location,
}) => {
  let requiredResources;
  requiredResources = findUmbraccoResources(
    resources,
    "Temporary workers handbook"
  );

  const { permissions, compliant, contractForServicesHandling } = appData;

  if (
    appData.responsibleTeam === "LIVR" ||
    appData.responsibleTeam === "LIVG"
  ) {
    requiredResources = [
      ...requiredResources,
      ...findUmbraccoResources(resources, "The Contact Company Booklet"),
    ];
  }

  requiredResources = [
    ...requiredResources,
    ...findUmbraccoResources(resources, "Anti-Bribery Policy"),
    ...findUmbraccoResources(
      resources,
      "Preventing Sexual Harassment Policy and procedure for Temporary Workers"
    ),
    ...findUmbraccoResources(resources, "Agency Workers, Know your Rights"),
    ...findUmbraccoResources(resources, "Whistleblowing Policy"),
    ...findUmbraccoResources(resources, "Candidate Account Terms of Use"),
  ];

  const kidCutoffDate = new Date("2020-04-06");
  const res = [...(requiredResources || [])];
  if (new Date(createdAt) > kidCutoffDate) {
    res.unshift(keyInformationDocument(appData, createdAt));
  }
  const createdDate = moment(createdAt).format("YYYY-MM-DD");
  const contractForServicesStartDate = "2021-09-01";
  const forceShowCFS =
    permissions &&
    (permissions.contractForServicesRecruitment ||
      permissions.contractForServicesDriving);

  if (
    compliant &&
    contractForServicesHandling &&
    (moment(createdDate).isAfter(contractForServicesStartDate) || forceShowCFS)
  ) {
    res.unshift(
      contractForServicesForm(
        appData,
        setContractForServicesSubmitted,
        location.state ? location.state.downloadViaSnackBar : false
      )
    );
  }

  return <Resources resources={res} title="HRGO" />;
};

ResourcesHRGOContainer.propTypes = {
  resources: arrayOf(
    shape({
      title: string.isRequired,
      description: string.isRequired,
      link: string,
      cta: string,
    })
  ),
  appData: object.isRequired,
  createdAt: string,
  setContractForServicesSubmitted: func,
  forceOpenCFS: bool,
  location: any,
};

const mapStateToProps = (state) => ({
  resources: state.core.umbracoContent.resources,
  appData: state.core.app,
  createdAt: state.core.app.createdAt,
});

const mapDispatchToProps = {
  setContractForServicesSubmitted: contractForServicesSubmitted,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ResourcesHRGOContainer);
